import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { FormState } from '../states/form.state';

export const selectFormFeature = (state: AppState) => state.form;

export const setForms = createSelector(
    selectFormFeature,
    (state: FormState) => state.forms
  );

export const setSelectedForm = createSelector(
    selectFormFeature,
    (state: FormState) => state.selectedForm
  );

export const setListStatus = createSelector(
    selectFormFeature,
    (state: FormState) => state.listStatus
);

export const setGetStatus = createSelector(
  selectFormFeature,
  (state: FormState) => state.getStatus
);

export const setUpdateStatus = createSelector(
  selectFormFeature,
  (state: FormState) => state.updateStatus
);

export const setCreateStatus = createSelector(
  selectFormFeature,
(state: FormState) => state.createStatus
);

export const setDeleteStatus = createSelector(
  selectFormFeature,
(state: FormState) => state.deleteStatus
);

export const setNewForm = createSelector(
  selectFormFeature,
  (state: FormState) => state.isNewForm
);

export const setCloneStatus = createSelector(
  selectFormFeature,
(state: FormState) => state.cloneStatus
);

/* export const selectForm = createSelector(
    selectFormFeature, (state: FormState) => state
) */